
function compileRegex(prefix, numbers) {
    return new RegExp(`^${prefix}\\d{${numbers}}$`)
}

const usPrefixes = [
    201,
    202,
    203,
    205,
    206,
    207,
    208,
    209,
    210,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    224,
    225,
    228,
    229,
    231,
    234,
    239,
    240,
    248,
    251,
    252,
    253,
    254,
    256,
    260,
    262,
    267,
    269,
    270,
    276,
    281,
    301,
    302,
    303,
    304,
    305,
    307,
    308,
    309,
    310,
    312,
    313,
    314,
    315,
    316,
    317,
    318,
    319,
    320,
    321,
    323,
    325,
    330,
    334,
    336,
    337,
    339,
    347,
    351,
    352,
    360,
    361,
    386,
    401,
    402,
    404,
    405,
    406,
    407,
    408,
    409,
    410,
    412,
    413,
    414,
    415,
    417,
    419,
    423,
    424,
    425,
    430,
    432,
    434,
    435,
    440,
    443,
    447,
    469,
    478,
    479,
    480,
    484,
    501,
    502,
    503,
    504,
    505,
    507,
    508,
    509,
    510,
    512,
    513,
    515,
    516,
    517,
    518,
    520,
    530,
    540,
    541,
    551,
    559,
    561,
    562,
    563,
    567,
    570,
    571,
    573,
    574,
    575,
    580,
    585,
    586,
    601,
    602,
    603,
    605,
    606,
    607,
    608,
    609,
    610,
    612,
    614,
    615,
    616,
    617,
    618,
    619,
    620,
    623,
    626,
    630,
    631,
    636,
    641,
    646,
    650,
    651,
    660,
    661,
    662,
    678,
    681,
    682,
    689,
    701,
    702,
    703,
    704,
    706,
    707,
    708,
    712,
    713,
    714,
    715,
    716,
    717,
    718,
    719,
    720,
    724,
    727,
    730,
    731,
    732,
    734,
    740,
    754,
    757,
    760,
    762,
    763,
    765,
    769,
    770,
    772,
    773,
    774,
    775,
    779,
    781,
    785,
    786,
    801,
    802,
    803,
    804,
    805,
    806,
    808,
    810,
    812,
    813,
    814,
    815,
    816,
    817,
    818,
    828,
    830,
    831,
    832,
    843,
    845,
    847,
    848,
    850,
    856,
    857,
    858,
    859,
    860,
    862,
    863,
    864,
    865,
    870,
    878,
    901,
    903,
    904,
    906,
    907,
    908,
    909,
    910,
    912,
    913,
    914,
    915,
    916,
    917,
    918,
    919,
    920,
    925,
    928,
    931,
    936,
    937,
    940,
    941,
    947,
    949,
    951,
    952,
    954,
    956,
    970,
    971,
    972,
    973,
    978,
    979,
    980,
    985,
    989,
]

function generateUSTypicalMap() {
    return usPrefixes.map((prefix) => {
        return compileRegex(prefix.toString(), 7)
    })
}

/**
 * @typedef {country: string, country_code: string, phone_type: string, country_regexes: RegExp[], country_iso: string} CountryRegex
 */

/**
 * @property {CountryRegex[]} regexMap
 */
const regexMap = [
    {
        'country': 'United States',
        'country_iso': 'US',
        'country_code': '1',
        'phone_type': 'other',
        'country_regexes': generateUSTypicalMap()
    },
    {
        'country': 'United Kingdom',
        'country_iso': 'GB',
        'country_code': '44',
        'phone_type': 'mobile',
        'country_regexes': [
            compileRegex('70', 8),
            compileRegex('71', 8),
            compileRegex('73', 8),
            compileRegex('74', 8),
            compileRegex('75', 8),
            compileRegex('76', 8),
            compileRegex('77', 8),
            compileRegex('78', 8),
            compileRegex('79', 8),
        ]
    },
    {
        'country': 'United Kingdom',
        'country_iso': 'GB',
        'country_code': '44',
        'phone_type': 'home',
        'country_regexes': [
            compileRegex('20', 8),
            compileRegex('247',7),
            compileRegex('29',8),
            compileRegex('113',7),
            compileRegex('114',7),
            compileRegex('121',7),
            compileRegex('131',7),
            compileRegex('141',7),
            compileRegex('151',7),
            compileRegex('161',7),
            compileRegex('1642',6),
            compileRegex('1223',6),
            compileRegex('1257',6),
            compileRegex('1382',6),
            compileRegex('1386',6),
            compileRegex('1935',6),
            compileRegex('1865',6),
            compileRegex('1772',6),
            compileRegex('1792',6),
            compileRegex('1204',6),
            compileRegex('15396',5),
            compileRegex('16977',4),
            compileRegex('16977',5),
            compileRegex('16064',5),
            compileRegex('16064',4),
            compileRegex('13873',5),
            compileRegex('15242',5),
            compileRegex('15394',5),
            compileRegex('15395',5),
            compileRegex('15396',5),
            compileRegex('16973',5),
            compileRegex('16974',5),
            compileRegex('16977',5),
            compileRegex('17683',5),
            compileRegex('17684',5),
            compileRegex('17687',5),
            compileRegex('19467',5),
            compileRegex('169770',4),
            compileRegex('1332050',3),
            compileRegex('1382006',3),
            compileRegex('141005',4),
            compileRegex('117101',4),
            compileRegex('11800',5),
            compileRegex('200003',4),
        ]
    },
    {
        'country': 'Israel',
        'country_iso': 'IL',
        'country_code': '972',
        'phone_type': 'home',
        'country_regexes': [
            compileRegex('2', 7),
            compileRegex('3', 7),
            compileRegex('4', 7),
            compileRegex('5', 7),
            compileRegex('6', 7),
        ]
    },
    {
        'country': 'Israel',
        'country_iso': 'IL',
        'country_code': '972',
        'phone_type': 'mobile',
        'country_regexes': [
            compileRegex('50', 7),
            compileRegex('51', 7),
            compileRegex('52', 7),
            compileRegex('53', 7),
            compileRegex('54', 7),
            compileRegex('5522',5),
            compileRegex('5566',5),
            compileRegex('5588',5),
            compileRegex('56',7),
            compileRegex('57',7),
            compileRegex('58',7),
            compileRegex('59',7),
            compileRegex('722',6),
            compileRegex('732',6),
            compileRegex('733',6),
            compileRegex('737',6),
            compileRegex('747',6),
            compileRegex('765',6),
            compileRegex('7688',5),
            compileRegex('77',7),
        ]
    }
]

export default function useCountryPrefixes() {

  return {
    regexMap,
  };
}
